import {groupBy, mapValues} from 'lodash'
import create, {createPublic} from './command' 
import {checkEdgeServers} from './edge'

export const profile = createPublic('myinfo')().then(([profile]) => profile)

export const getEdgeServers = () => profile.then(checkEdgeServers)

export const institutionCourses = create('institution', 'courses')()

export const languages = create('support', 'languages')()

export const subjects = createPublic('subjects')()

export const periodTypes = create('grading', 'getPeriodTypes')()
export const periodTypesMap = periodTypes.then(associate('id', 'name'))

export const gradingCategories = create('grading', 'getCategory')()
export const gradingCategoryMap = gradingCategories.then(associate('id', 'name'))

export const summaryTypes = create('grading', 'getSummaryTypes')()

export const grades = create('catalog', 'grades')()
export const gradePrecedence = grades.then(associate('id','precedence'))

export const translations = createPublic('translations')({prefix: 'new-edufile'})
  .then(associate('name','language', 'value'))

export const settings = create('web', 'settings')({Prefix: 'new-edufile'})
  .then(associate('name','value'))

export const templateTypes = (process.env.NODE_ENV == 'production')
  ? create('assessment', 'template_types')()
    .catch(() => [])
  : []

export const quizTypes = create('quiz', 'getTypes')()
export const quizTypesMap = quizTypes.then(associate('id', 'name'))

export const quizQuestionTypes = create('quiz', 'getQuestionTypes')()

export const quizStandardScale = create('quiz', 'getStandardScale')()

function associate(head, ...keys) {
  return (data) => keys.length > 0
    ? mapValues(groupBy(data, (item) => item[head]), associate(...keys))
    : data[0][head]
}

export const courses = create('catalog', 'courses')().then(data => {
  const [availableLanguages, ...coursesData] = data
  const courses = Object.entries(coursesData.reduce((acc, course) => {
    if (acc[course.name]) acc[course.name].push(course)
    else acc[course.name] = [course]
    return acc
  }, {})).reduce((acc, [name ,courses]) => acc.concat(courses.length > 1 ? courses.map(c => ({...c, notUniqueName: true})) : courses), [])  
  return courses
})

const getHomeworkStatus = create('homework','getHomeworkStatus')()
export const homeworkStatus = getHomeworkStatus.then(associate('id', 'name'))
export const homeworkStatusMap = getHomeworkStatus.then(associate('name', 'id'))
